<script lang="ts">
    export let order: Order
    let innerWidth = 0

    $: isMobile = innerWidth < 1700
    $: items = isMobile
        ? [`Auftrags-Nr. ${order.generalDetails.number}`]
        : [
              `Auftrags-Nr. ${order.generalDetails.number}`,
              new Date(order.insertTime).toLocaleDateString("de-DE"),
              order.generalDetails.caller.name,
              order.generalDetails.caller.companyName,
          ]
</script>

<svelte:window bind:innerWidth="{innerWidth}" />
<div class="col1">
    <span>Auftrag</span>
    <div>
        <img
            src="../../../assets/icons/solar_checklist-outline.svg"
            alt="icon"
        />
        <ul class="ulcontent">
            {#each items as item}
                <li class="contentTextBold">{item}</li>
            {/each}
        </ul>
    </div>
</div>

<style lang="less">
    .col1 {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
        span {
            font-family: Inter-Bold;
            font-size: 0.5rem;
            line-height: 0.5rem;
            font-weight: 700;
            text-transform: uppercase;
        }

        & > div {
            display: flex;
            gap: 0.6rem;
            .ulcontent {
                display: flex;
                align-items: center;
                li {
                    border-left: 1px solid var(--white-100);
                    padding: 0px 0.6rem;
                    height: fit-content;
                    font-size: 1.2rem;
                    font-weight: 400;
                    font-family: Inter-Regular;
                    line-height: 1.2rem;
                    color: var(--white-100);
                    &:first-child {
                        border-left: none;
                        padding-left: 0px;
                    }
                }
            }
        }
    }
</style>
